import { ReadySidePanel } from './ReadySidePanel';
import { connectReadySidePanel } from './ReadySidePanel.connect';

export const ConnectedReadySidePanel = connectReadySidePanel(ReadySidePanel);
